// material-ui
import Drawer from "@mui/material/Drawer";
import { CSSObject, styled, Theme } from "@mui/material/styles";

// project imports
import { DRAWER_WIDTH } from "config";

const openedMixin = (theme: Theme) =>
  ({
    width: DRAWER_WIDTH,
    borderRight: "1px solid",
    borderRightColor: theme.palette.divider,

    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),

    overflowX: "hidden",
    boxShadow: "none",
    ...theme.applyStyles("dark", { boxShadow: theme.customShadows.z1 }),
  }) as CSSObject;

const closedMixin = (theme: Theme) =>
  ({
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),

    overflowX: "hidden",
    width: theme.spacing(7.5),
    borderRight: "none",
    boxShadow: theme.customShadows.z1,
  }) as CSSObject;

// ==============================|| DRAWER - MINI STYLED ||============================== //

const MiniDrawerStyled = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
  width: DRAWER_WIDTH,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  variants: [
    {
      props: ({ open }) => open,
      style: {
        ...openedMixin(theme),
        "& .MuiDrawer-paper": openedMixin(theme),
      },
    },
    {
      props: ({ open }) => !open,
      style: {
        ...closedMixin(theme),
        "& .MuiDrawer-paper": closedMixin(theme),
      },
    },
  ],
}));

export default MiniDrawerStyled;
